import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { catchError, map, of } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Quick synchronous check of localStorage
  const storedAuth = authService.getAuthFromLocalStorage();

  if (storedAuth && storedAuth.session) {
    // User has stored session, allow access
    return true;
  }

  // If local storage is empty, verify whether Amplify still has a valid session.
  return authService.getUserBySession().pipe(
    map((session) => {
      if (session && session.session) {
        return true;
      }

      return router.createUrlTree(['/auth/login']);
    }),
    catchError(() => of(router.createUrlTree(['/auth/login']))),
  );
};
